import React, { useContext, useState } from "react"
import { MasterButton, Modal, ModalDeleteConfirm } from "App/Component/ui"
import { DISABLED_BUTTON_SUBMIT, instance2, instance3 } from "App/constants"
import { getTagihanById, urlAddTagihan, getTotalSaldoByTagihanId } from "."
import { FormContext } from "../context/FormContext"
import {
  defaultToastError,
  toUTCFormat,
  defaultToastSuccess,
  isNull,
  today,
  convertToValidPrice,
  scrollToTop,
} from "App/utils/helpers"

import { getKunjunganByTagihanId, validationInputTagihan } from "./helpers"

import {
  STATUS_OPEN_DRAFT_TAGIHAN,
  SHOW_BUKA_TRANSAKSI,
  SHOW_KUNCI_TRANSAKSI,
  STATUS_KUNCI_TAGIHAN,
  SHOW_KUNCI_TUTUP_KUNJUNGAN,
  SHOW_BUKA_KUNCI_TRANSAKSI,
  SHOW_UPDATE_TRANSAKSI,
  RESET_BUTTON_FORCE,
  SHOW_TUTUP_TRANSAKSI,
  STATUS_TUTUP_TAGIHAN,
  SHOW_BUKA_TUTUP_TRANSAKSI,
} from "utils/billing"
import { WarningIcon } from "App/Assets"
import { Grid } from "@material-ui/core"

const ModalSimpan = ({ setShowModal }) => {
  const { formData, setFormData, setFormError } = useContext(FormContext)

  return (
    <Modal title={"Simpan"} show={setShowModal} width="20%">
      <ButtonActionBukaTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionUpdateTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionKunciTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionBukaKembaliTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionTutupTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      {formData.status_tagihan === STATUS_TUTUP_TAGIHAN && (
        <ButtonActionBukaTutupTransaksi
          formData={formData}
          setFormData={setFormData}
          setFormError={setFormError}
          setShowModal={setShowModal}
        />
      )}
    </Modal>
  )
}

export default ModalSimpan

const ButtonActionBukaTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI)

  const handleClickBukaTransaksi = async () => {
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post(urlAddTagihan, {
          rm_id: formData.rm_id,
          kelas_id: formData.kelas_id,
          no_asuransi: formData.asuransi_no,
          tanggal_tagihan: toUTCFormat(formData.date),
          nama: formData.rm_name,
          jenis_layanan_id: formData.jenis_layanan_id,
          no_npwp: formData.no_npwp,
          penanggung: formData.penanggung,
          untuk_pembayaran: formData.untuk_pembayaran,
          no_sep: formData.no_sep,
          keterangan: formData.keterangan,
          asuransi_id: formData.asuransi_id,
          kunjungan_id: formData.kunjungan_id,
          rm_umur: formData.rm_umur,
          rm_tanggal_lahir: toUTCFormat(formData.rm_tanggal_lahir),
          biaya_administrasi: isNull(formData.biaya_administrasi)
            ? 0
            : formData.biaya_administrasi,
          is_paket: formData.is_paket,
          company_id: formData.company_id ?? null,
        })

        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message)
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)

          const resp = await getTagihanById(res.data.id)
          const totalSaldo = await getTotalSaldoByTagihanId(res.data.id)

          if (resp.state) {
            const tagihan = resp.data.tagihan
            const pembayaran = resp.data.pembayaran
            const ditanggung = resp.data.ditanggung

            setFormData({
              ...formData,
              tagihan_id: res.data.id,
              total_saldo: totalSaldo.data,
              status_tagihan: STATUS_OPEN_DRAFT_TAGIHAN,
              tagihan: {
                jumlah: tagihan.jumlah,
                potongan: tagihan.potongan,
                tax: tagihan.tax,
              },

              pembayaran: {
                total_tagihan: pembayaran.total_tagihan,
                total_pembayaran: pembayaran.total_pembayaran,
              },

              ditanggung: {
                ditanggung: ditanggung.ditanggung,
                total_tagihan: ditanggung.total_tagihan,
                jumlah_selisih: ditanggung.jumlah_selisih,
              },
            })
            setFormError(null)
          }
          setShowModal(false)
        } else {
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN &&
    isNull(formData.tagihan_id)
  ) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaTransaksi.color}
          name={disabledBukaTransaksi.label}
          disabled={disabledBukaTransaksi.state}
          size="lg"
          onClick={(e) => handleClickBukaTransaksi(e)}
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionUpdateTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledUpdateTransaksi, setDisabledUpdateTransaksi] = useState(
    SHOW_UPDATE_TRANSAKSI,
  )

  const handleClickUpdateTransaksi = async () => {
    setDisabledUpdateTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/tagihan/update", {
          id: formData.tagihan_id,
          rm_id: formData.rm_id,
          kelas_id: formData.kelas_id,
          no_asuransi: formData.asuransi_no,
          tanggal_tagihan: toUTCFormat(formData.date),
          nama: formData.rm_name,
          jenis_layanan_id: formData.jenis_layanan_id,
          no_npwp: formData.no_npwp,
          penanggung: formData.penanggung,
          untuk_pembayaran: formData.untuk_pembayaran,

          no_sep: formData.no_sep,
          keterangan: formData.keterangan,
          asuransi_id: formData.asuransi_id,
          kunjungan_id: formData.kunjungan_id,
          rm_umur: formData.rm_umur,
          biaya_administrasi: isNull(formData.biaya_administrasi)
            ? 0
            : formData.biaya_administrasi,
          is_paket: formData.is_paket,
          company_id: formData.company_id ?? null,
        })

        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message)
          setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)

          const resp = await getTagihanById(formData.tagihan_id)
          const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

          if (resp.state) {
            const tagihan = resp.data.tagihan
            const pembayaran = resp.data.pembayaran
            const ditanggung = resp.data.ditanggung

            setFormData({
              ...formData,
              total_saldo: totalSaldo.data,
              status_tagihan: STATUS_OPEN_DRAFT_TAGIHAN,
              tagihan: {
                jumlah: tagihan.jumlah,
                potongan: tagihan.potongan,
                tax: tagihan.tax,
              },

              pembayaran: {
                total_tagihan: pembayaran.total_tagihan,
                total_pembayaran: pembayaran.total_pembayaran,
              },

              ditanggung: {
                ditanggung: ditanggung.ditanggung,
                total_tagihan: ditanggung.total_tagihan,
                jumlah_selisih: ditanggung.jumlah_selisih,
              },
            })
            setFormError(null)
          }
          setShowModal(false)
        } else {
          setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN &&
    !isNull(formData.tagihan_id)
  ) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledUpdateTransaksi.color}
          name={disabledUpdateTransaksi.label}
          disabled={disabledUpdateTransaksi.state}
          size="lg"
          onClick={(e) => handleClickUpdateTransaksi(e)}
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionBukaKembaliTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaKembaliTransaksi, setDisabledBukaKembaliTransaksi] =
    useState(SHOW_BUKA_KUNCI_TRANSAKSI)

  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-open",
  })

  const handleClickBukaKembaliTransaksi = async () => {
    setDisabledBukaKembaliTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/tagihan/buka-kembali-tagihan", {
          id: formData.tagihan_id,
        })

        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message)
          setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)

          const resp = await getTagihanById(formData.tagihan_id)
          const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

          if (resp.state) {
            const tagihan = resp.data.tagihan
            const pembayaran = resp.data.pembayaran
            const ditanggung = resp.data.ditanggung

            setFormData({
              ...formData,
              total_saldo: totalSaldo.data,
              status_tagihan: STATUS_OPEN_DRAFT_TAGIHAN,
              tagihan: {
                jumlah: tagihan.jumlah,
                potongan: tagihan.potongan,
                tax: tagihan.tax,
              },

              pembayaran: {
                total_tagihan: pembayaran.total_tagihan,
                total_pembayaran: pembayaran.total_pembayaran,
              },

              ditanggung: {
                ditanggung: ditanggung.ditanggung,
                total_tagihan: ditanggung.total_tagihan,
                jumlah_selisih: ditanggung.jumlah_selisih,
              },
            })
            setFormError(null)
          }
          setShowModal(false)
        } else {
          setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (formData.status_tagihan === STATUS_KUNCI_TAGIHAN) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-open") {
                handleClickBukaKembaliTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-lock",
              })
            }
            labelConfirm="Ya, buka kunci transaksi"
            msg="Apakah anda yakin membuka kunci transaksi ini?"
            title="Konfirmasi Buka Kunci Transaksi"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaKembaliTransaksi.color}
          name={disabledBukaKembaliTransaksi.label}
          disabled={disabledBukaKembaliTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              type: "only-open",
              state: !showModalConfirm.state,
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionKunciTransaksi = ({
  formData,
  setFormData,
  setShowModal,
  setFormError,
}) => {
  const [disabledKunciTransaksi, setDisabledKunciTransaksi] =
    useState(SHOW_KUNCI_TRANSAKSI)

  const [disabledKunciDanTutupKunjungan, setDisabledKunciDanTutupKunjungan] =
    useState(SHOW_KUNCI_TUTUP_KUNJUNGAN)
  const [showModalForce, setShowModalForce] = useState(RESET_BUTTON_FORCE)
  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-lock",
  })

  const handleClickKunciTransaksi = async (e, force = false) => {
    setDisabledKunciTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const oldTagihan = await getTagihanById(formData.tagihan_id)
      const res = await instance3.post("/tagihan/kunci-tagihan", {
        id: formData.tagihan_id,
        totalTagihan: convertToValidPrice(
          oldTagihan.data.tagihan.total_tagihan,
        ),
        date: toUTCFormat(today()),
        force: force,
        selisih_paket: convertToValidPrice(
          oldTagihan.data.totalPaket.jumlah_selisih,
        ),
        selisih_ditanggung: convertToValidPrice(
          oldTagihan.data.ditanggung.jumlah_selisih,
        ),
      })
      if (res.data.status === 200) {
        const resp = await getTagihanById(formData.tagihan_id)
        const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
        if (resp.state) {
          const tagihan = resp.data.tagihan
          const pembayaran = resp.data.pembayaran
          const ditanggung = resp.data.ditanggung
          const totalPaket = resp.data.totalPaket

          setFormData({
            ...formData,
            total_saldo: totalSaldo.data,
            status_tagihan: STATUS_KUNCI_TAGIHAN,
            tagihan: {
              jumlah: tagihan.jumlah,
              potongan: tagihan.potongan,
              tax: tagihan.tax,
            },

            pembayaran: {
              total_tagihan: pembayaran.total_tagihan,
              total_pembayaran: pembayaran.total_pembayaran,
            },

            ditanggung: {
              ditanggung: ditanggung.ditanggung,
              total_tagihan: ditanggung.total_tagihan,
              jumlah_selisih: ditanggung.jumlah_selisih,
            },

            totalPaket: {
              total_tagihan: totalPaket.total_tagihan,
              total_paket: totalPaket.total_paket,
              jumlah_selisih: totalPaket.jumlah_selisih,
            },
          })
          defaultToastSuccess(res.data.message)
          setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
          setShowModal(false)
          setFormError(null)
        }
        setShowModalConfirm({
          state: false,
          type: "only-lock",
        })
        setShowModal(false)
      } else if (parseInt(res.data.status) === 214) {
        setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
        setShowModalForce({
          ...showModalForce,
          state: true,
          message: res.data.list_id_penjualan,
          type: 1,
        })
      } else {
        setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
        defaultToastError(res.data.message)
        setShowModalForce(RESET_BUTTON_FORCE)
      }
    } catch (error) {
      setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
      setShowModalForce(RESET_BUTTON_FORCE)
    }
  }

  const handleClickKunciDanTutupKunjungan = async (e, force = false) => {
    setDisabledKunciDanTutupKunjungan(DISABLED_BUTTON_SUBMIT)
    try {
      const oldTagihan = await getTagihanById(formData.tagihan_id)
      const res = await instance3.post("/tagihan/kunci-tagihan", {
        id: formData.tagihan_id,
        totalTagihan: convertToValidPrice(
          oldTagihan.data.tagihan.total_tagihan,
        ),
        date: toUTCFormat(today()),
        force: force,
        selisih_paket: convertToValidPrice(
          oldTagihan.data.totalPaket.jumlah_selisih,
        ),
        selisih_ditanggung: convertToValidPrice(
          oldTagihan.data.ditanggung.jumlah_selisih,
        ),
      })

      if (res.data.status === 200) {
        const resp = await getTagihanById(formData.tagihan_id)
        const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
        const kunjunganList = await getKunjunganByTagihanId(formData.tagihan_id)

        if (kunjunganList.state) {
          const kunjunganID = []
          kunjunganList.data.filter((item) =>
            kunjunganID.push(item.kunjungan_id),
          )

          if (kunjunganID.length > 0) {
            await instance2.post(
              "/registration/registration/tutupregistrasi_multiple",
              {
                tanggal_selesai: today(true),
              },
              {
                headers: {
                  regisarr: kunjunganID.toString(),
                },
              },
            )
          }
        }

        if (resp.state) {
          const tagihan = resp.data.tagihan
          const pembayaran = resp.data.pembayaran
          const ditanggung = resp.data.ditanggung
          const totalPaket = resp.data.totalPaket

          setFormData({
            ...formData,
            total_saldo: totalSaldo.data,
            status_tagihan: STATUS_KUNCI_TAGIHAN,
            tagihan: {
              jumlah: tagihan.jumlah,
              potongan: tagihan.potongan,
              tax: tagihan.tax,
            },

            pembayaran: {
              total_tagihan: pembayaran.total_tagihan,
              total_pembayaran: pembayaran.total_pembayaran,
            },

            ditanggung: {
              ditanggung: ditanggung.ditanggung,
              total_tagihan: ditanggung.total_tagihan,
              jumlah_selisih: ditanggung.jumlah_selisih,
            },

            totalPaket: {
              total_tagihan: totalPaket.total_tagihan,
              total_paket: totalPaket.total_paket,
              jumlah_selisih: totalPaket.jumlah_selisih,
            },
          })
          defaultToastSuccess(res.data.message)
          setDisabledKunciDanTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
          setShowModal(false)
          setFormError(null)
        }
        setShowModal(false)
      } else {
        if (res.data.status === 214) {
          setShowModalForce({
            ...showModalForce,
            state: true,
            message: res.data.list_id_penjualan,
            type: 2,
          })
          setDisabledKunciDanTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
        } else {
          setDisabledKunciDanTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
          defaultToastError(res.data.message)
          setShowModalForce(RESET_BUTTON_FORCE)
        }
      }
    } catch (error) {
      setDisabledKunciDanTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
      defaultToastError(error?.response?.data?.message)
      setShowModalForce(RESET_BUTTON_FORCE)
    }
  }

  if (
    formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN &&
    !isNull(formData.tagihan_id)
  ) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-lock") {
                handleClickKunciTransaksi(e)
              } else if (showModalConfirm.type === "with-close-kunjungan") {
                handleClickKunciDanTutupKunjungan(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-lock",
              })
            }
            labelConfirm="Ya, kunci transaksi"
            msg="Apakah anda yakin mengunci transaksi ini?"
            title="Konfirmasi Kunci Transaksi"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledKunciTransaksi.color}
          name={disabledKunciTransaksi.label}
          disabled={disabledKunciTransaksi.state}
          size="lg"
          onClick={(e) => {
            setShowModalConfirm({
              type: "only-lock",
              state: !showModalConfirm.state,
            })
          }}
        />

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledKunciDanTutupKunjungan.color}
          name={disabledKunciDanTutupKunjungan.label}
          disabled={disabledKunciDanTutupKunjungan.state}
          size="lg"
          onClick={(e) => {
            setShowModalConfirm({
              type: "with-close-kunjungan",
              state: !showModalConfirm.state,
            })
          }}
        />

        {showModalForce.state && (
          <ModalConfirmForceKunciTagihan
            setShowModal={() => setShowModalForce(RESET_BUTTON_FORCE)}
            batalHandle={() => setShowModalForce(RESET_BUTTON_FORCE)}
            confirmHandle={(e) => {
              setShowModalForce({
                ...showModalForce,
                force: true,
                clicked: true,
              })
              if (parseInt(showModalForce.type) === 1) {
                handleClickKunciTransaksi(e, true)
              } else if (parseInt(showModalForce.type) === 2) {
                handleClickKunciDanTutupKunjungan(e, true)
              }
            }}
            message={showModalForce.message}
            clicked={showModalForce.clicked}
          />
        )}
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionTutupTransaksi = ({
  formData,
  setFormData,
  setShowModal,
  setFormError,
}) => {
  const [disabledTutupTransaksi, setDisabledTutupTransaksi] =
    useState(SHOW_TUTUP_TRANSAKSI)
  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-close",
  })

  const handleClickTutupTransaksi = async () => {
    setDisabledTutupTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const oldTagihan = await getTagihanById(formData.tagihan_id)
      const res = await instance3.post("/tagihan/tutup-tagihan", {
        id: formData.tagihan_id,
        totalTagihan: convertToValidPrice(
          oldTagihan.data.tagihan.total_tagihan,
        ),
        date: toUTCFormat(today()),
      })
      if (res.data.status === 200) {
        const resp = await getTagihanById(formData.tagihan_id)
        const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

        if (resp.state) {
          const tagihan = resp.data.tagihan
          const pembayaran = resp.data.pembayaran
          const ditanggung = resp.data.ditanggung
          const totalPaket = resp.data.totalPaket

          setFormData({
            ...formData,
            total_saldo: totalSaldo.data,
            status_tagihan: STATUS_TUTUP_TAGIHAN,
            tagihan: {
              jumlah: tagihan.jumlah,
              potongan: tagihan.potongan,
              tax: tagihan.tax,
            },

            pembayaran: {
              total_tagihan: pembayaran.total_tagihan,
              total_pembayaran: pembayaran.total_pembayaran,
            },

            ditanggung: {
              ditanggung: ditanggung.ditanggung,
              total_tagihan: ditanggung.total_tagihan,
              jumlah_selisih: ditanggung.jumlah_selisih,
            },

            totalPaket: {
              total_tagihan: totalPaket.total_tagihan,
              total_paket: totalPaket.total_paket,
              jumlah_selisih: totalPaket.jumlah_selisih,
            },
          })
          defaultToastSuccess(res.data.message)
          setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
          setShowModal(false)
          setFormError(null)
        }
        setShowModal(false)
      } else {
        setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
        defaultToastError(res.data.message)
      }
    } catch (error) {
      setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_tagihan === STATUS_KUNCI_TAGIHAN &&
    !isNull(formData.tagihan_id)
  ) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-close") {
                handleClickTutupTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-close",
              })
            }
            labelConfirm="Ya, tutup transaksi"
            msg="Apakah anda yakin mentutup transaksi ini?"
            title="Konfirmasi Tutup Transaksi"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledTutupTransaksi.color}
          name={disabledTutupTransaksi.label}
          disabled={disabledTutupTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              state: !showModalConfirm.state,
              type: "only-close",
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionBukaTutupTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaTutupTransaksi, setDisabledBukaTutupTransaksi] = useState(
    SHOW_BUKA_TUTUP_TRANSAKSI,
  )

  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-open",
  })

  const handleClickBukaTutupTransaksi = async () => {
    setDisabledBukaTutupTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/tagihan/buka-tutup-tagihan", {
          id: formData.tagihan_id,
        })

        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message)
          setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)

          const resp = await getTagihanById(formData.tagihan_id)
          const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

          if (resp.state) {
            const tagihan = resp.data.tagihan
            const pembayaran = resp.data.pembayaran
            const ditanggung = resp.data.ditanggung

            setFormData({
              ...formData,
              total_saldo: totalSaldo.data,
              status_tagihan: STATUS_KUNCI_TAGIHAN,
              tagihan: {
                jumlah: tagihan.jumlah,
                potongan: tagihan.potongan,
                tax: tagihan.tax,
              },

              pembayaran: {
                total_tagihan: pembayaran.total_tagihan,
                total_pembayaran: pembayaran.total_pembayaran,
              },

              ditanggung: {
                ditanggung: ditanggung.ditanggung,
                total_tagihan: ditanggung.total_tagihan,
                jumlah_selisih: ditanggung.jumlah_selisih,
              },
            })
            setFormError(null)
          }
          setShowModal(false)
        } else {
          setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (formData.status_tagihan === STATUS_TUTUP_TAGIHAN) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-open") {
                handleClickBukaTutupTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-open",
              })
            }
            labelConfirm="Ya, buka transaksi"
            msg="Apakah anda yakin membuka transaksi ini?"
            title="Konfirmasi Buka Tutup Transaksi"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaTutupTransaksi.color}
          name={disabledBukaTutupTransaksi.label}
          disabled={disabledBukaTutupTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              state: !showModalConfirm.state,
              type: "only-open",
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}

function ModalConfirmForceKunciTagihan({
  setShowModal,
  confirmHandle,
  batalHandle,
  message,
  clicked,
}) {
  return (
    <>
      <Modal
        backgroundTitle="red"
        title={"Konfirmasi"}
        width={"30%"}
        show={setShowModal}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <WarningIcon width="150px" height="150px" />
          <p>
            Terdapat penjualan yang masih open draft, apakah anda ingin mengunci
            tagihan dan penjualannya?
          </p>
        </div>
        <p>LIST PENJUALAN ID BELUM TERKUNCI</p>
        <p>{message.toString()}</p>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color="secondary"
            name="Batal"
            onClick={batalHandle}
            size="md"
          />
          <MasterButton
            className={"mt-1"}
            type={"button"}
            color={clicked ? "secondary" : "danger"}
            onClick={confirmHandle}
            disabled={clicked}
            name={clicked ? "Loading..." : "Ya, saya yakin"}
            size="md"
          />
        </Grid>
      </Modal>
    </>
  )
}
